export default "__VITE_ASSET__DS6fE$sr__"